import { Show, useTranslate } from "react-admin"
import InvoiceLayout from "../invoices/InvoiceLayout"

const DraftShow = () => {
  
  const translate = useTranslate()

  return (
    <Show title={translate("resources.drafts.name", {smart_count: 1})} >
      <InvoiceLayout resource="drafts" isPreview={false} />
    </Show>
  )
}

export default DraftShow